"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = [{
  title: "Boy Names",
  description: "Discover strong, classic, and modern names for your little boy. Browse our comprehensive alphabetical list.",
  path: "/BoyNamesPage"
}, {
  title: "Girl Names",
  description: "Explore beautiful, elegant, and meaningful names for your baby girl. Find the perfect fit for her personality.",
  path: "/GirlNamesPage"
}, {
  title: "Unique Names",
  description: "Find rare and distinctive names that stand out from the crowd. Perfect for parents seeking something truly special.",
  path: "/UniqueNamesPage"
}, {
  title: "Trending Names",
  description: "Stay up-to-date with the most popular names parents are choosing right now. See what's capturing hearts this year.",
  path: "/TrendingPage"
}, {
  title: "Biblical Names",
  description: "Browse timeless and traditional names with deep historical and spiritual roots. A collection of enduring classics.",
  path: "/BiblicalPage"
}];
export default function OurCuratedCollections() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-curated-collections" className="bg-background py-24 px-4 md:px-8">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-16 text-center">
          <h2 className="text-primary text-4xl md:text-5xl font-bold mb-4">
            Our Curated Collections
          </h2>
          <p className="text-foreground text-lg max-w-2xl mx-auto">
            Explore our meticulously organized lists to find the perfect name for your newest family member.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, i) => <div data-index={i} key={category.title} className="h-full">
              <Card className="group h-full flex flex-col bg-card rounded-none border-none p-12 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:brightness-95 cursor-pointer">
                <h3 className="text-primary text-3xl font-bold mb-4 transition-colors duration-300 group-hover:text-accent">
                  {category.title}
                </h3>
                <p className="text-foreground text-lg line-clamp-2 mb-8 flex-grow">
                  {category.description}
                </p>
                <div className="mt-auto">
                  <Link to={category.path} className="inline-flex items-center gap-2 text-secondary font-semibold text-lg transition-colors duration-300 group-hover:text-accent">
                    Explore List
                    <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}